function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
    	//determine if the site is in mobile mode
      const mediaQuery = window.matchMedia('(min-width: 749px)');
    	if (mediaQuery.matches) {
          	
          	 Array.from( document.querySelectorAll('[data-selected-non-variant-image]')).forEach(x => x.removeAttribute('data-selected-non-variant-image'));	
             let parent = this.parentElement;
             if(!parent.nodeName.toLowerCase() == "li" )return false;
             if(parent.dataset.variantColor) return false;
             parent.setAttribute('data-selected-non-variant-image','true');
          	 let x = document.querySelector('variant-selects'); 	
          	 let update_media_event = new CustomEvent('nonVariantImageClicked');
             x.dispatchEvent(update_media_event);
          	 let disable_atc_event = new CustomEvent('addToCartDisable');
 			 x.dispatchEvent(disable_atc_event);
		}
      
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
	
    this.slider.addEventListener('scroll', this.update.bind(this));
    
     // Setup isScrolling variable
    
		
// var isScrolling;

// let that  = this;
// this.slider.addEventListener('scroll',function ( event ) {

// // 	// Clear our timeout throughout the scroll
// window.clearTimeout( isScrolling );

// // 	// Set a timeout to run after scrolling ends
// isScrolling = setTimeout(function() {

// // 		// Run the callback
      
//        const sliderItemsInView = Array.from(that.sliderItems).filter(element => isInViewport(element));
// 		let go_to_color  = sliderItemsInView[0].dataset.variantColor;
//   		console.log('goto color',go_to_color);
// 		if(typeof go_to_color === 'undefined'){
//           	let x = document.querySelector('variant-selects');
// 			let event = new CustomEvent('addToCartDisable');
// 			x.dispatchEvent(event);	}
      
// //     	set_color_option(go_to_color);
// //         let x = document.querySelector('variant-selects');
// // 		let event = new CustomEvent('variantImageScrolled');
// // 	  	x.dispatchEvent(event);	

// }, 300);

// })
    
    
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
    
    
    var isScrolling;
    let that  = this;
this.slider.addEventListener('scroll',function ( event ) {

// Clear our timeout throughout the scroll
window.clearTimeout( isScrolling );

// // 	// Set a timeout to run after scrolling ends
isScrolling = setTimeout(function() {
 Array.from(document.querySelectorAll("div[data-oos-color-form]")).forEach(x => x.style.display = 'none');
  	
		// Run the callback
      
// const sliderItemsInView = Array.from(that.sliderItems).filter(element => isInViewport(element));
// let go_to_color  = sliderItemsInView[0].dataset.variantColor;

// if(typeof go_to_color === 'undefined'){
  
//            	let x = document.querySelector('variant-selects');
//  			let event = new CustomEvent('addToCartDisable');
//   			if(x){ 
//               x.dispatchEvent(event);	
//             }
// 		}
      
// //     	set_color_option(go_to_color);
// //         let x = document.querySelector('variant-selects');
// // 		let event = new CustomEvent('variantImageScrolled');
// // 	  	x.dispatchEvent(event);	

}, 300);
})
    
    
    
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class HeroSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.heroSlider = this.querySelector('[id^="Slider-"]');
    this.heroSliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableHeroSliderLooping = false;
    this.heroCurrentPageElement = this.querySelector('.slider-counter--current');
    this.heroPageTotalElement = this.querySelector('.slider-counter--total');
    this.heroPrevButton = this.querySelector('button[name="previous"]');
    this.heroNextButton = this.querySelector('button[name="next"]');

    if (!this.heroSlider || !this.heroNextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.heroSlider);

    this.heroSlider.addEventListener('scroll', this.update.bind(this));
    this.heroPrevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.heroNextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.heroSliderItemsToShow = Array.from(this.heroSliderItems).filter(element => element.clientWidth > 0);
    if (this.heroSliderItemsToShow.length < 2) return;
    this.heroSliderItemOffset = this.heroSliderItemsToShow[1].offsetLeft - this.heroSliderItemsToShow[0].offsetLeft;
    this.heroSlidesPerPage = Math.floor((this.heroSlider.clientWidth - this.heroSliderItemsToShow[0].offsetLeft) / this.herSliderItemOffset);
    this.heroTotalPages = this.heroSliderItemsToShow.length - this.heroSlidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.heroSliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.heroSlider || !this.heroNextButton) return;

    const heroPreviousPage = this.heroCurrentPage;
    this.heroCurrentPage = Math.round(this.heroSlider.scrollLeft / this.heroSliderItemOffset) + 1;

    if (this.heroCurrentPageElement && this.heroPageTotalElement) {
      this.heroCurrentPageElement.textContent = this.heroCurrentPage;
      this.heroPageTotalElement.textContent = this.heroTotalPages;
    }

    if (this.heroCurrentPage != heroPreviousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        heroCurrentPage: this.heroCurrentPage,
        heroCurrentElement: this.heroSliderItemsToShow[this.heroCurrentPage - 1]
      }}));
    }

    if (this.enableHeroSliderLooping) return;

    if (this.isSlideVisible(this.heroSliderItemsToShow[0]) && this.heroSlider.scrollLeft === 0) {
      this.heroPrevButton.setAttribute('disabled', 'disabled');
    } else {
      this.heroPrevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.heroSliderItemsToShow[this.heroSliderItemsToShow.length - 1])) {
      this.heroNextButton.setAttribute('disabled', 'disabled');
    } else {
      this.heroNextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const heroLastVisibleSlide = this.heroSlider.clientWidth + this.heroSlider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= heroLastVisibleSlide && element.offsetLeft >= this.heroSlider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.heroSlideScrollPosition = event.currentTarget.name === 'next' ? this.heroSlider.scrollLeft + (step * this.heroSliderItemOffset) : this.heroSlider.scrollLeft - (step * this.heroSliderItemOffset);
    this.heroSlider.scrollTo({
      left: this.heroSlideScrollPosition
    });
  }
}

customElements.define('hero-slider-component', HeroSliderComponent);


class HeroSlideshowComponent extends HeroSliderComponent {
  constructor() {
    super();
    this.heroSliderControlWrapper = this.querySelector('.slider-buttons-dawn');
    this.enableHeroSliderLooping = true;

    if (!this.heroSliderControlWrapper) return;

    this.heroSliderFirstItemNode = this.heroSlider.querySelector('.slideshow__slide');
    if (this.heroSliderItemsToShow.length > 0) this.heroCurrentPage = 1;

    this.heroSliderControlLinksArray = Array.from(this.heroSliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.heroSliderControlLinksArray.forEach(link => link.addEventListener('click', this.heroLinkToSlide.bind(this)));
    this.heroSlider.addEventListener('scroll', this.heroSetSlideVisibility.bind(this));
    this.heroSetSlideVisibility();

    if (this.heroSlider.getAttribute('data-autoplay') === 'true') this.heroSetAutoPlay();
  }

  heroSetAutoPlay() {
    this.heroSliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.heroAutoplaySpeed = this.heroSlider.dataset.speed * 1000;

    this.heroSliderAutoplayButton.addEventListener('click', this.heroAutoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.heroFocusInHandling.bind(this));
    this.addEventListener('mouseleave', this.heroFocusOutHandling.bind(this));
    this.addEventListener('focusin', this.heroFocusInHandling.bind(this));
    this.addEventListener('focusout', this.heroFocusOutHandling.bind(this));

    this.heroPlay();
    this.heroAutoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.heroCurrentPage === 1;
    const isLastSlide = this.heroCurrentPage === this.heroSliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.heroSlideScrollPosition = this.heroSlider.scrollLeft + this.heroSliderFirstItemNode.clientWidth * this.heroSliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.heroSlideScrollPosition = 0;
    }
    this.heroSlider.scrollTo({
      left: this.heroSlideScrollPosition
    });
  }

  update() {
    super.update();
    this.heroSliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.heroPrevButton.removeAttribute('disabled');

    if (!this.heroSliderControlButtons.length) return;

    this.heroSliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.heroSliderControlButtons[this.heroCurrentPage - 1].classList.add('slider-counter__link--active');
    this.heroSliderControlButtons[this.heroCurrentPage - 1].setAttribute('aria-current', true);
  }

  heroAutoPlayToggle() {
    this.heroTogglePlayButtonState(this.heroAutoplayButtonIsSetToPlay);
    this.heroAutoplayButtonIsSetToPlay ? this.heroPause() : this.heroPlay();
    this.heroAutoplayButtonIsSetToPlay = !this.heroAutoplayButtonIsSetToPlay;
  }

  heroFocusOutHandling(event) {
    const heroFocusedOnAutoplayButton = event.target === this.heroSliderAutoplayButton || this.heroSliderAutoplayButton.contains(event.target);
    if (!this.heroAutoplayButtonIsSetToPlay || heroFocusedOnAutoplayButton) return;
    this.heroPlay();
  }

  heroFocusInHandling(event) {
    const heroFocusedOnAutoplayButton = event.target === this.heroSliderAutoplayButton || this.heroSliderAutoplayButton.contains(event.target);
    if (heroFocusedOnAutoplayButton && this.heroAutoplayButtonIsSetToPlay) {
      this.heroPlay();
    } else if (this.heroAutoplayButtonIsSetToPlay) {
      this.heroPause();
    }
  }

  heroPlay() {
    this.heroSlider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.heroAutoRotateSlides.bind(this), this.heroAutoplaySpeed);
  }

  heroPause() {
    this.heroSlider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  heroTogglePlayButtonState(heroPauseAutoplay) {
    if (heroPauseAutoplay) {
      this.heroSliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.heroSliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.heroSliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.heroSliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  heroAutoRotateSlides() {
    const heroSlideScrollPosition = this.heroCurrentPage === this.heroSliderItems.length ? 0 : this.heroSlider.scrollLeft + this.heroSlider.querySelector('.slideshow__slide').clientWidth;
    this.heroSlider.scrollTo({
      left: heroSlideScrollPosition
    });
  }

  heroSetSlideVisibility() {
    this.heroSliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.heroCurrentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  heroLinkToSlide(event) {
    event.preventDefault();
    const heroSlideScrollPosition = this.heroSlider.scrollLeft + this.heroSliderFirstItemNode.clientWidth * (this.heroSliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.heroCurrentPage);
    this.heroSlider.scrollTo({
      left: heroSlideScrollPosition
    });
  }
}

customElements.define('hero-slideshow-component', HeroSlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    let that = this;
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('variantImageClicked',this.onVariantChange);
    this.addEventListener('variantImageScrolled',this.onVariantScroll);
    this.addEventListener('addToCartDisable', this.disableButton);
    this.addEventListener('nonVariantImageClicked', this.onNonVariantChange);
    this.checkDisableATC();
  }
  
  onNonVariantChange(){
    this.closeAllOOSForms();
    const newMedia = document.querySelector(`[data-selected-non-variant-image="true"]`);
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView(); });

  }
  

  disableButton(){
  	  this.toggleAddButton(true, 'Choose a Color', false);
    setChooseAColor();
  }
  
  onVariantScroll() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      //this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  
  onVariantChange() {
    this.closeAllOOSForms();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView(); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.checkDisableATC();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  closeAllOOSForms(){
    let color = this.querySelector('select').value
    let oosFormToShow = document.querySelector('#esc-oos-form[data-oos-color-form="' + color +'"]')
    if(Array.from){
      Array.from(document.querySelectorAll('div[data-oos-color-form]')).forEach(
        function (x) { if (x.dataset.oosColorForm === color) {x.style.display="block"
          } else {x.style.display = 'none'}
                     })
    }
    if (!oosFormToShow) {
      if(document.getElementById('turning-sale-on')) {
        if (document.getElementById('sitewide-sale-message')){
          document.getElementById('sitewide-sale-message').style.display = 'inline-block'
        }            
    }
  } else {
    if (oosFormToShow.style.display === "block") {
      if (document.getElementById('sitewide-sale-message')) {
            document.getElementById('sitewide-sale-message').style.display = 'none'
              }
    }}
  }
  
  checkDisableATC(){
    let value = this.querySelector('select').value;
    let types_to_disable = [
      {selector:`[data-prelaunch-status="prelaunch"]`,display_message:"Coming Soon!"},
      {selector:`[data-unavailable="true"]`,display_message:"Unavailable"}]
    if(value){

        types_to_disable.forEach( type => {
            let corresponding_image = document.querySelector(`figure[data-variant-color="${value}"]${type.selector}`);
            if(corresponding_image){
                 this.toggleAddButton(true,type.display_message);
                 updateOOSForm(value);
            }
        })
    }
     
}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class BhCollectionVideo extends HTMLElement {

   constructor() {
    super();
     this.imageLeft = this.getAttribute('left-image') || 'https://cdn.shopify.com/s/files/1/1410/9094/files/2210_HTile_best-sellers_1.jpg?v=166273467';
  
     this.imageRight = this.getAttribute('right-image') || 'https://cdn.shopify.com/s/files/1/1410/9094/files/2210_HTile_see-whats-new_1.jpg?v=1662733075';
     
     this.imageLeftMobile = this.getAttribute('left-image-mobile') || 'https://cdn.shopify.com/s/files/1/1410/9094/files/2210_skinny-banner_best-sellers.jpg?v=1662750630';

     this.imageRightMobile = this.getAttribute('right-image-mobile') || 'https://cdn.shopify.com/s/files/1/1410/9094/files/2210_skinny-banner_see-whats-new.jpg?v=1662750630';
     
     this.imageLeftLink= this.getAttribute('left-image-link') || "#";
     this.imageRightLink= this.getAttribute('right-image-link') || "#";
     this.youtubeID = this.getAttribute('youtubeID');
     let olderIDs=[];
      olderIDs["HbOVSYB_zFU"]= 'sddefault';
      olderIDs["Rt4Qsn138E8"]= 'sddefault';
      olderIDs["s4Y1FQZUDos"] =  'hqdefault';
      olderIDs["PmsLVgGyCAM"] =  'hqdefault';
      olderIDs["BvHgiPWUZVw"] =  'hqdefault';
      olderIDs["KOtdV7mIQSA"]  = 'sddefault';
      
     this.olderIDs = olderIDs;
     this.zoomBackground = this.getAttribute('zoom-background')  === "true" ? 'transform: scale(1.4);padding-top: 20px;' : '' ;

     this.banner_url = this.getAttribute('banner-url');
       
     this.render();
     
   }

  // component attributes
  static get observedAttributes() {
    return ['imageLeft','imageRight','youtubeID','imageLeftLink','imageRightLink'];
  }

  attributeChangedCallback(property, oldValue, newValue) {

    
    this[ property ] = newValue;
    
  }

  
    youTubePlayer(id) {
      document.getElementById("ytid-" + id).style.display = 'none'; 
      document.getElementById("ytp-" + id).height = "835";
      document.getElementById("ytp-" + id).style.display = '';
      document.getElementById("ytp-" + id).src = 'https://www.youtube.com/embed/'+id+'?autoplay=1&modestbranding=1&rel=0';
  
      let mobile = this.getElementsByClassName('mobile_sml');
      let desktop = this.getElementsByClassName('desktop');
      let container = this.getElementsByClassName('yt-banners-container');
      
      
      for (let i = 0; i < mobile.length; i++) {
          mobile[i].style.display = '';
          desktop[i].style.display = 'none';
          
      }
      container[0].style.display = 'initial'
    }


  
  render(){
    let video_image_type = 'maxresdefault';
    let video_image_style = this.zoomBackground;
    let older_video_ids = Object.keys(this.olderIDs);
    if(older_video_ids.includes(this.youtubeID)){
      video_image_type = this.olderIDs[this.youtubeID]
      video_image_style = video_image_style.replace('20px','70px');
      
    }
    let video_image = this.banner_url === "" ? `https://img.youtube.com/vi/${this.youtubeID}/${video_image_type}.jpg` : this.banner_url;  
   
    let banner_template = `
    <div style="text-align: center;" class="yt-banners-container">  
    
    <iframe id="ytp-${this.youtubeID}" class="ytp" title="YouTube video player" src="" height="315" width="100%" allowfullscreen="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" frameborder="0" style="display:none"></iframe>
    
    <a href="${this.imageLeftLink}" style="width:100%;" class='yt-video-banner desktop'>
    <div style="background-image:url('${this.imageLeft}');background-position: center;height:100%;width:100%;background-repeat: no-repeat;
    background-size: cover;" >
    &nbsp;
    </div>
    </a>
    
    <div class="video_container" id="ytid-${this.youtubeID}" style="overflow:hidden;">
    <img src="${video_image}" style="width:100%;${video_image_style}" class="img_dims">
        <div class="playbutton" style="position:absolute;left:0px;top:0px;"> </div>
        
    </div>
    
    
    
    <a href="${this.imageRightLink}" style="width:100%;" class='yt-video-banner desktop'>
      <div style="background-image:url('${this.imageRight}');background-position: center;height:100%;width:100%;background-repeat: no-repeat;
    background-size: cover;">
      &nbsp;
      </div>
    </a> <!-- mobile sml -->
    
    <div class="row">
      <div class="column1">
    <a href="${this.imageLeftLink}" class="mobile_sml" style="display:none"><img src="${this.imageLeftMobile}" alt="Best Sellers" width="100%" class="sort_banners"></a>
      </div>
      <div class="column2">
    <a href="${this.imageRightLink}" class="mobile_sml" style="display:none"><img src="${this.imageRightMobile}" alt="New Arrivals" width="100%" class="sort_banners"></a>
      </div>
    </div>
    </div>
    `;
   
      this.insertAdjacentHTML('beforeend',banner_template);
      this.querySelector(`#ytid-${this.youtubeID}`).addEventListener('click',e => {  this.youTubePlayer(this.youtubeID)  });
    
  }

}
customElements.define('bh-collection-video',BhCollectionVideo);